module.exports = __webpack_public_path__ + "img/map.0d95cc95.png";